"use client";

import { createAuthClient } from "better-auth/react";
import { twoFactorClient } from "better-auth/client/plugins";

/**
 * Browser-side auth client.
 *
 * No baseURL: the client calls same-origin `/api/auth/*`, which keeps it
 * correct across localhost, previews and production without an env var that
 * can be wrong in exactly one environment.
 */
export const authClient = createAuthClient({
  plugins: [twoFactorClient()],
});

// Note: `forgetPassword` was renamed `requestPasswordReset` in Better Auth 1.6.
export const {
  signIn,
  signUp,
  signOut,
  useSession,
  requestPasswordReset,
  resetPassword,
} = authClient;
